// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5fdd2f6","455":"1a7cba9e"}[chunkId] + ".chunk.js";
};